// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1X7QZ","header":"ReportDetails_header__3-Xa0","title":"ReportDetails_title__nUFE8","left":"ReportDetails_left__2OR0t"};